import { commonApis } from "stores/common/commonApis";

/** In-memory cache so Explore can remount without a blank Market Pulse flash. */
let currentPulseCache = null;
let currentPulsePromise = null;

/**
 * Fetches market pulse from `/dashboard/market-pulse`.
 * Current responses are cached for instant reuse across Explore remounts.
 * @param {"current"|"historical"} type
 * @param {string} [cursor] — for historical pagination (`nextCursor`)
 * @param {{ force?: boolean }} [options]
 */
export const fetchMarketPulse = async ({
  type = "current",
  cursor,
  force = false,
} = {}) => {
  if (type === "current" && !force && currentPulseCache) {
    return currentPulseCache;
  }

  if (type === "current" && currentPulsePromise && !force) {
    return currentPulsePromise;
  }

  const request = commonApis
    .getMarketPulse({ type, cursor })
    .then((response) => {
      if (type === "current" && response) {
        currentPulseCache = response;
      }
      return response;
    })
    .finally(() => {
      if (type === "current") {
        currentPulsePromise = null;
      }
    });

  if (type === "current") {
    currentPulsePromise = request;
  }

  return request;
};

export const getCachedCurrentMarketPulse = () => currentPulseCache;

/**
 * Always hits the network, then updates the current-pulse cache.
 * Use for stale-while-revalidate refreshes.
 */
export const refreshCurrentMarketPulse = async () => {
  return fetchMarketPulse({ type: "current", force: true });
};
